import { FC } from "react";
import { Card, Stack, Text } from "@shopify/polaris";
import { SubscriptionPlan } from "@prisma/client";

import SubmitButton from "./components/SubmitButton.jsx";
import PriceSection from "./components/PriceSection.js";
import ListSection from "./components/ListSection.js";
import { SUBSCRIPTION_PLAN_ENTERPRISE } from "../../../../../../../constants/subscriptionPlans.js";
import SaveUp from "../../../SaveUp/SaveUp.js";
import styles from "./PlanCard.module.css";

interface PlanCardProps {
  plan: (SubscriptionPlan & { isCustom?: boolean }),
  shopifyAppSubscriptionInterval: string;
  subscriptionInterval: string;
}

const PlanCard: FC<PlanCardProps> = ({ plan, shopifyAppSubscriptionInterval, subscriptionInterval }) => {
  if (plan.name === SUBSCRIPTION_PLAN_ENTERPRISE) return null
  return (
    <div className={styles["planCard"]}>
      <Card>
        <Card.Section>
          <Stack distribution={"center"}>
            <Text variant="headingLg" as="h5">
              {plan.name.toUpperCase()}
            </Text>
          </Stack>
        </Card.Section>
        <Card.Section>
          <Stack vertical distribution={"center"}>
            <PriceSection
              plan={plan}
              subscriptionInterval={subscriptionInterval}
              shopifyAppSubscriptionInterval={shopifyAppSubscriptionInterval}
            />
            <ListSection
              plan={plan}
            />
          </Stack>
        </Card.Section>
        <Card.Section>
          <Stack distribution={"center"}>
            <SubmitButton
              plan={plan}
              subscriptionInterval={subscriptionInterval}
              shopifyAppSubscriptionInterval={shopifyAppSubscriptionInterval}
            />
          </Stack>
        </Card.Section>
      </Card>
      {plan.name === SUBSCRIPTION_PLAN_ENTERPRISE && <SaveUp />}
    </div>
  );
};

export default PlanCard;